// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__1B2fs","Open":"SideDrawer_Open__18vlW","Close":"SideDrawer_Close__1Hvrz","Logo":"SideDrawer_Logo__3BVaW"};